$(document).ready(function () {
  // Initialize Content Slider
  $(".home-upcoming-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    dots: false,
    autoplay: false,
    autoplaySpeed: 4000,
    asNavFor: ".home-bg-slider", // Sync with the background image slider
    prevArrow:
      '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
    nextArrow:
      '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>',
  });

  // Initialize Background Image Slider
  $(".home-bg-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    dots: true,
    autoplay: false,
    autoplaySpeed: 4000,
    fade: true, // Smooth transition for background images
    asNavFor: ".home-upcoming-slider", // Sync with the content slider
  });

  $(".blog_events").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    dots: true,
    autoplay: false,
    autoplaySpeed: 4000,
    fade: true, // Smooth transition for background images
  });
});

// UPLOAD PO Number
document.addEventListener("DOMContentLoaded", function () {
  const checkbox = document.getElementById("po-toggle-checkbox");
  const poDetails = document.getElementById("po-details-section");
  const poFile = document.getElementById("po-file");
  const poNumber = document.getElementById("po-number");
  const progressBar = document.getElementById("progress-bar");
  const uploadStatus = document.getElementById("upload-status");
  const uploadedFiles = document.getElementById("uploaded-files");
  const addToCartBtn = document.querySelector(
    'form[action^="/cart"] [type="submit"]'
  );

  checkbox.addEventListener("change", function () {
    if (checkbox.checked) {
      poDetails.style.display = "block";
      addToCartBtn.disabled = true;
    } else {
      poDetails.style.display = "none";
      addToCartBtn.disabled = false;
      progressBar.style.width = "0%";
      uploadStatus.textContent = "";
      uploadedFiles.innerHTML = "";
      poFile.value = "";
      poNumber.value = "";
      // Optional: reset cart note via API
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: "" }),
      });
    }
  });

  poFile.addEventListener("change", function () {
    const file = poFile.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("files[]", file);

    const xhr = new XMLHttpRequest();
    xhr.open(
      "POST",
      "https://rosybrown-louse-801309.hostingersite.com/pmbiomedical/api_upload.php",
      true
    );

    xhr.upload.addEventListener("progress", function (e) {
      if (e.lengthComputable) {
        const percent = (e.loaded / e.total) * 100;
        progressBar.style.width = percent + "%";
        uploadStatus.textContent = `Uploading... ${Math.round(percent)}%`;
      }
    });

    xhr.onload = function () {
      if (xhr.status === 200) {
        try {
          const response = JSON.parse(xhr.responseText);
          if (response.success && response.uploaded && response.uploaded[0]) {
            const uploadedFile = response.uploaded[0];

            uploadedFiles.innerHTML = `<a target="_blank" href="${uploadedFile.url}">${uploadedFile.name}</a>`;
            uploadStatus.textContent = "Upload complete!";

            const poValue = poNumber.value || "N/A";
            const note = `PO Number: ${poValue}\n ${uploadedFile.url}`;

            // ✅ Call Shopify Cart API to set the note
            fetch("/cart/update.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ note }),
            })
              .then((res) => res.json())
              .then(() => {
                console.log("Cart note updated successfully");
                addToCartBtn.disabled = false;
              })
              .catch((err) => {
                console.error("Failed to update cart note:", err);
                uploadStatus.textContent =
                  "Upload succeeded, but failed to update cart note.";
              });
          } else {
            uploadStatus.textContent = "Upload failed. Please try again.";
            addToCartBtn.disabled = true;
          }
        } catch (err) {
          uploadStatus.textContent = "Invalid server response.";
          addToCartBtn.disabled = true;
        }
      } else {
        uploadStatus.textContent =
          "Upload failed. Server returned " + xhr.status;
        addToCartBtn.disabled = true;
      }
    };

    xhr.onerror = function () {
      uploadStatus.textContent = "Network error during upload.";
      addToCartBtn.disabled = true;
    };

    xhr.send(formData);
  });
});


document.addEventListener("DOMContentLoaded", function () {

  const productButtons = document.querySelector(".product-form__buttons");
  if (!productButtons) return;

  const submitBtn = document.querySelector("#ProductSubmitButton-template--25463886905660__main");
  if (!submitBtn) return;

  // Create message element
  const outOfStockMsg = document.createElement("div");
  outOfStockMsg.textContent = "Out of Stock";
  outOfStockMsg.style.color = "red";
  outOfStockMsg.style.fontWeight = "bold";
  outOfStockMsg.style.marginBottom = "10px";
  outOfStockMsg.style.display = "none";

  // Insert message above button area
  productButtons.parentNode.insertBefore(outOfStockMsg, productButtons);

  // Function to update message visibility
  function updateMessage() {
    if (submitBtn.hasAttribute("disabled")) {
      outOfStockMsg.style.display = "block";
    } else {
      outOfStockMsg.style.display = "none";
    }
  }

  // Run on page load
  updateMessage();

  // Observe for changes to the button (Shopify updates it dynamically)
  const observer = new MutationObserver(updateMessage);
  observer.observe(submitBtn, { attributes: true, attributeFilter: ["disabled"] });
});
